import { render, staticRenderFns } from "./ConfirmCloseSync.vue?vue&type=template&id=3d667faa&"
import script from "./ConfirmCloseSync.vue?vue&type=script&lang=js&"
export * from "./ConfirmCloseSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports